module.exports = "<div class=\"input-control\" ng-class=\"{loading: $ctrl.loading, focused: $ctrl.focused, open: $ctrl.isOpen}\"><input autocomplete=\"off\" class=\"input-xlarge\" ng-model=\"$ctrl.label\" ng-change=\"$ctrl.filterSuggestions()\" ng-focus=\"$ctrl.onFocus()\" ng-blur=\"$ctrl.onBlur()\"></div><div ng-show=\"$ctrl.isOpen\" class=\"select-dropdown\"><div class=\"select-dropdown-option\" ng-repeat=\"suggestion in $ctrl.filteredSuggestions\" ng-mousedown=\"$ctrl.setValue(suggestion, $index)\" ng-bind-html=\"$ctrl.getDropdownLabel(suggestion)\"></div></div>"


//////////////////
// WEBPACK FOOTER
// ./src/filter/query-builder/filter-value-input.component.html
// module id = 301
// module chunks = 0